import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import './FormActionButtons.css';

const FormActionButtons = ({
  onCancel,
  disabled = false,
  /** When true, Cancel is disabled and styled (e.g. during submit so navigation cannot race the request). */
  cancelDisabled = false,
  isSubmitting = false,
  isEditMode = false,
  cancelLabel = 'Cancel',
  addLabel = 'Add',
  updateLabel = 'Update',
  submittingLabel,
  /** `"inventory"` sets primary to #0F172B via CSS variables on the wrapper */
  variant = '',
  submitStyle = {}
}) => {

  const wrapClass = ['shared-form-action-buttons', variant === 'inventory' && 'shared-form-action-buttons--inventory']
    .filter(Boolean)
    .join(' ');

  const getSubmittingText = () => {
    if (submittingLabel) return submittingLabel;
    return isEditMode ? (updateLabel !== 'Update' ? `${updateLabel}...` : 'Updating...') : (addLabel !== 'Add' ? `${addLabel}...` : 'Adding...');
  };

  return (
    <div className={wrapClass}>
      <button
        type="button"
        className="shared-form-action-btn shared-form-action-btn-cancel"
        onClick={onCancel}
        disabled={cancelDisabled}
      >
        {cancelLabel}
      </button>
      <button
        type="submit"
        className="shared-form-action-btn shared-form-action-btn-add"
        disabled={disabled}
        style={submitStyle}
      >
        {isSubmitting ? (
          <>
            <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
            {getSubmittingText()}
          </>
        ) : (
          <>{isEditMode ? updateLabel : addLabel}</>
        )}

      </button>
    </div>
  );
};

export default FormActionButtons;
